<template>
  <v-row justify="center">
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="500"
      persistent
      scrollable
    >
      <v-card>
        <v-toolbar
          color="transparent"
          flat
          height="70"
          max-height="70"
        >
          <v-toolbar-title class="pl-3 brand-green-dark--text">
            <div class="brand-text-title mt-1">
              {{ $t('Auth.ResetPasswordDialog.Title').toLocaleUpperCase($i18n.locale) }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            :height="$vuetify.breakpoint.smAndDown ? 40 : 50"
            :width="$vuetify.breakpoint.smAndDown ? 40 : 50"
            class="ma-0"
            color="brand-green-dark"
            icon
            outlined
            style="background-color: white;"
            @click="closeDialog"
          >
            <v-icon small>
              mdi-close
            </v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4 pt-0 pb-2">
          <v-divider class="brand-green-dark" />

          <v-form
            v-if="model"
            ref="form"
            v-model="isFormValid"
            @submit.prevent
          >
            <v-container fluid>
              <v-row dense>
                <v-col
                  class="py-4 brand-text-small brand-grey--text"
                  cols="12"
                >
                  {{ $t('Auth.ResetPasswordDialog.Subtitle') }}
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="model.Email"
                    :hint="$t('Auth.ResetPasswordDialog.Field.Email.Hint')"
                    :label="$t('Auth.ResetPasswordDialog.Field.Email.Label')"
                    :placeholder="$t('Auth.ResetPasswordDialog.Field.Email.Placeholder')"
                    :rules="model.validator.vuetifyFormFieldRules('Email')"
                    clearable
                    dense
                    name="Email"
                    outlined
                    type="text"
                  />
                </v-col>

                <v-col
                  v-if="showGenericError && genericError"
                  class="py-0"
                  cols="12"
                >
                  <v-alert
                    border="left"
                    dense
                    text
                    type="error"
                  >
                    {{ genericError }}
                  </v-alert>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <v-btn
                    :disabled="isFormSaving || !isFormValid"
                    :loading="isFormSaving"
                    block
                    class="brand-green-dark--text"
                    color="brand-primary"
                    depressed
                    x-large
                    @click="onResetPasswordClick"
                  >
                    <span class="brand-text-heading">{{ $t('Auth.Button.ResetPassword').toLocaleUpperCase($i18n.locale) }}</span>
                  </v-btn>
                </v-col>

                <v-col cols="12">
                  <v-btn
                    block
                    class="text-none mt-3"
                    color="brand-green-dark"
                    plain
                    small
                    @click="onLoginClick"
                  >
                    <span class="brand-text-small">{{ $t('Auth.Button.WithAccount') }}</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

import ResetPasswordDialogMixin from '@/theme/default/components/login/ResetPasswordDialog.js'

export default {
  name  : 'ResetPasswordDialog',
  mixins: [ResetPasswordDialogMixin]
}
</script>

<style scoped src="@/theme/default/components/login/ResetPasswordDialog.css"></style>

<style scoped>
</style>
